import { CircularProgress } from "@mui/material";

import "./LoadingCircle.scss";

interface LoadingCircleProps {
  size?: number;
  className?: string;
}

const LoadingCircle = (props: LoadingCircleProps) => {
  const { size, className } = props;
  return (
    <CircularProgress
      size={size}
      className={"loadingCircle " + className}
      data-testid="loadingCircle"
    />
  );
};

export default LoadingCircle;
